import { render, staticRenderFns } from "./CPOPastAndFwdsChart.vue?vue&type=template&id=5d56b506&scoped=true&"
import script from "./CPOPastAndFwdsChart.vue?vue&type=script&lang=js&"
export * from "./CPOPastAndFwdsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d56b506",
  null
  
)

export default component.exports